Number.prototype.fixTo = function (to) {
    var number = this;

    if (number) {
        return (Math.round(Math.round(number * Math.pow(10, to + 1)) / 10) / Math.pow(10, to));
    } else {
        return 0;
    }
};

Number.prototype.toFixedGood = function (to = 2) {
    var number = this;

    if (number) {
        return Number(number).fixTo(to).toFixed(to).replace(".", ",");
    } else {
        return "0,00";
    }
};

String.prototype.toNumber = function () {
    return Number(this);
};
